module.exports = __webpack_public_path__ + "fonts/roboto-mono-v13-latin-regular.d8ab6e6b.woff2";